import PolicyLayoutComponent from '@/components/layouts/policy-layout/policy-layout.component';
import {RouteConfig} from 'vue-router';
import RefundPolicyEnComponent from '../refundPolicy/refund-policy-en.component';
import RefundPolicyKrComponent from '../refundPolicy/refund-policy-kr.component';

export const PolicyRoutes: Array<RouteConfig> = [
    {
        path: '/policy',
        name: 'policy',
        component: PolicyLayoutComponent,
        redirect: {name: 'policy'},
        children: [
            {
                path: 'refund-policy-en',
                name: 'refund-policy-en',
                component: RefundPolicyEnComponent,
            },
            {
                path: 'refund-policy-kr',
                name: 'refund-policy-kr',
                component: RefundPolicyKrComponent,
            },
        ],
    },
];
